import axios from "axios";
import React, { useState, useEffect } from "react";
import config from "../../api_config.json";
import { useAppContext } from "../../context";
import { useAuth0 } from "../../react-auth0-spa";
import { Select } from "antd";

const query = `
query Orgs {
  organizzaziones(first: 10000, order: nome_ASC) {
    edges{
      node{
        objectId
        nome
      }
    }
  }
}`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

const SelectOrg = (props) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    const fetchOrgs = async () => {
      if (props.orgs) {
        setOrgs(props.orgs);
        return;
      }
      const token = await getTokenSilently();

      const graphqlUrl = `${config.baseUrl[env]}/graphql`;
      const response = await axios({
        method: "post",
        url: graphqlUrl,
        data: {
          query,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = response?.data;
      const fetchedOrgs = Array.isArray(responseData)
        ? responseData
        : (
            responseData?.organizzaziones?.edges ||
            responseData?.data?.organizzaziones?.edges ||
            []
          ).map((edge) => edge?.node).filter(Boolean);
      if (props.orgsToExclude) {
        setOrgs(
          fetchedOrgs.filter(
            (org) => !props.orgsToExclude.includes(org.objectId)
          )
        );
      } else {
        setOrgs(fetchedOrgs);
      }
    };
    fetchOrgs();
  }, [env, getTokenSilently, props.orgs, props.orgsToExclude]);

  return (
    <Select
      allowClear={props.allowClear}
      disabled={props.disabled}
      loading={props.loading}
      placeholder={props.placeholder}
      showSearch
      optionFilterProp="label"
      style={props.style}
      value={props.value}
      onChange={props.onChange}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={orgs.map((org) => {
        return { value: org.objectId, label: `${org.nome} - ${org.objectId}` };
      })}
    />
  );
};

export default SelectOrg;
